const STORAGE_KEY = 'talenthouse_jobs'

const DEFAULT_JOBS = [
  {
    id: 1,
    title: 'Civil Engineer',
    company: 'BuildRight Construction',
    location: 'Auckland',
    sector: 'Engineering',
    type: 'Full-time',
    salary: '$110k',
    active: true,
    description: 'We are looking for an experienced Civil Engineer to join our team.',
    requirements: 'Bachelor degree in Civil Engineering, 5+ years experience.',
    links: [{ text: 'Apply Now', url: 'https://example.com/apply/1' }]
  },
  {
    id: 2,
    title: 'Registered Nurse',
    company: 'Auckland Health Plus',
    location: 'Wellington',
    sector: 'Health Care',
    type: 'Full-time',
    salary: '$85k',
    active: true,
    description: 'Join our healthcare team as a Registered Nurse.',
    requirements: 'Nursing degree, current registration.',
    links: [{ text: 'Apply Now', url: 'https://example.com/apply/2' }]
  },
  {
    id: 3,
    title: 'Financial Analyst',
    company: 'NZ Finance Solutions',
    location: 'Christchurch',
    sector: 'Finance',
    type: 'Full-time',
    salary: '$95k',
    active: true,
    description: 'Financial Analyst position available in Christchurch.',
    requirements: 'Finance degree, 3+ years experience.',
    links: [{ text: 'Apply Now', url: 'https://example.com/apply/3' }]
  }
]

const loadJobs = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : DEFAULT_JOBS
  } catch {
    return DEFAULT_JOBS
  }
}

const saveJobs = (jobs) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(jobs))
}

const getAllJobs = () => loadJobs()

const getActiveJobs = () => {
  const now = new Date()
  return loadJobs().filter(job => {
    if (!job.active) return false
    if (job.expiryDate && new Date(job.expiryDate) < now) return false
    return true
  })
}

const addJob = (jobData) => {
  const jobs = loadJobs()
  const newJob = { ...jobData, id: Date.now() }
  saveJobs([...jobs, newJob])
  window.dispatchEvent(new CustomEvent('jobsChanged', { detail: { action: 'add', job: newJob } }))
  return newJob
}

const updateJob = (jobId, jobData) => {
  const jobs = loadJobs()
  const index = jobs.findIndex(job => job.id === jobId)
  if (index === -1) return null
  const updatedJob = { ...jobs[index], ...jobData }
  const updatedJobs = jobs.map((job, i) => i === index ? updatedJob : job)
  saveJobs(updatedJobs)
  window.dispatchEvent(new CustomEvent('jobsChanged', { detail: { action: 'update', job: updatedJob } }))
  return updatedJob
}

const deleteJob = (jobId) => {
  const jobs = loadJobs()
  saveJobs(jobs.filter(job => job.id !== jobId))
  window.dispatchEvent(new CustomEvent('jobsChanged', { detail: { action: 'delete', jobId } }))
  return true
}

export { getAllJobs, getActiveJobs, addJob, updateJob, deleteJob }
